import React from 'react';
import cn from 'classnames';
import { DH } from '../../../../../utils/DataHook';
import * as s from './styles.scss';

export const Description: React.FunctionComponent<{
  title: string;
  subtitle?: string;
  moreInfoLabel?: string;
  onMoreInfoClick?(): void;
  isSinglePaymentMethodOption?: boolean;
}> = ({
  title,
  subtitle,
  moreInfoLabel,
  onMoreInfoClick,
  isSinglePaymentMethodOption,
}) => {
  return (
    <div
      data-hook={DH.PaymentMethod.Wallet.StaticInstallment.Description}
      className={cn(s.description, {
        [s.singlePaymentDescription]: isSinglePaymentMethodOption,
      })}
    >
      <span
        className={cn(s.title, {
          [s.singlePaymentMethodTitle]: isSinglePaymentMethodOption,
        })}
      >
        {title}
      </span>
      <span className={s.noWrapContainer}>
        {subtitle && <span>{subtitle}</span>}
        {moreInfoLabel && onMoreInfoClick && (
          <button
            data-hook={DH.PaymentMethod.Wallet.StaticInstallment.MoreInfoButton}
            className={s.moreInfoButton}
            onClick={onMoreInfoClick}
          >
            {moreInfoLabel}
          </button>
        )}
      </span>
    </div>
  );
};
Description.displayName = 'Description';
